import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { Dtc } from '../../../../shared/models/dtc/dtc';
import { DtcApiService } from '../../../services/api/dtc-api.service';
import { Stepper } from '../../common/stepper/stepper';
import { ChangesInOtherVersionsTable } from '../../tables/changes-in-other-versions-table/changes-in-other-versions-table';
import { PropagateChangesToEntitiesInOtherVersionsModalBase } from './propagate-changes-to-entities-in-other-versions-modal';
import { AgentActionDirective } from '../../../directives/agent-action.directive';

@Component({
  selector: 'app-propagate-dtc-changes-to-entities-in-other-versions-modal',
  imports: [ChangesInOtherVersionsTable, Stepper, AgentActionDirective],
  templateUrl: './propagate-changes-to-entities-in-other-versions-modal.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './propagate-changes-to-entities-in-other-versions-modal.scss',
})
export class PropagateDtcChangesToEntitiesInOtherVersionsModal extends PropagateChangesToEntitiesInOtherVersionsModalBase<Dtc> {
  protected readonly propertyUpdateInfoApi = inject(DtcApiService);

  protected override get agentBusinessObject(): string {
    return 'dtc';
  }
}
